import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { AdminUiDetailsService } from '../../../admin-ui-details/admin-ui-details.service';

@Component({
  selector: 'osn-cxb-targeting-control',
  templateUrl: './targeting-control.component.html',
  styleUrls: ['./targeting-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TargetingControlComponent implements OnInit, OnDestroy {
  @Input() public hasCountryTargeting = false;
  @Input() public hasUserTargeting = false;
  @Input() public hasPlatformTargeting = false;

  public isTargetingVisible$ = new BehaviorSubject<boolean>(false);
  private readonly destroyed$ = new Subject<void>();
  public readonly currentPageActions$ = this.adminUiDetailsService.currentPageActions$.pipe(takeUntil(this.destroyed$));

  constructor(private readonly adminUiDetailsService: AdminUiDetailsService) {}

  public ngOnInit(): void {
    this.currentPageActions$.subscribe(({ isPlatformEnabled, isUserSegmentEnabled }) => {
      const isPlatformTargetingVisible = isPlatformEnabled && this.hasPlatformTargeting;
      const isUserTargetingVisible = isUserSegmentEnabled && this.hasUserTargeting;
      const isTargetingVisible = this.hasCountryTargeting || isPlatformTargetingVisible || isUserTargetingVisible;

      this.isTargetingVisible$.next(isTargetingVisible);
    });
  }

  public ngOnDestroy(): void {
    this.isTargetingVisible$.complete();
  }
}
